var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('sitemap', {
    staticClass: "sitemap--small"
  });

}
var staticRenderFns = []

export { render, staticRenderFns }